// Templates prédéfinis pour les problèmes récurrents de la Ligne B3
export const FORM_TEMPLATES = {
  // Problèmes mécaniques
  mechanical: {
    category: "🔧 Problèmes Mécaniques",
    templates: [
      {
        id: "conveyor_jam",
        name: "Bourrage Convoyeur",
        icon: "🚛",
        description: "Blocage ou bourrage du système de convoyage",
        data: {
          probleme_initial: "Bourrage détecté au niveau du convoyeur",
          phenomene_produit: "Arrêt inattendu du convoyeur avec accumulation de produits",
          phenomene_ideal: "Convoyeur fonctionnant en continu sans interruption",
          check_maintenance: "nok",
          check_maintenance_details: "Vérification de l'état des courroies et guides nécessaire",
          actions_entreprise: "• Arrêt sécurisé de la ligne\n• Dégagement manuel des produits bloqués\n• Inspection visuelle du mécanisme",
          cout_estime: "500",
          priorite: "haute"
        }
      },
      {
        id: "motor_failure",
        name: "Panne Moteur",
        icon: "⚡",
        description: "Dysfonctionnement moteur électrique",
        data: {
          probleme_initial: "Panne moteur détectée - arrêt machine",
          phenomene_produit: "Moteur ne démarre pas ou s'arrête de façon inattendue",
          phenomene_ideal: "Moteur fonctionne normalement selon les paramètres de production",
          check_maintenance: "nok",
          check_defaut: "nok",
          check_defaut_details: "Contrôle électrique et thermique du moteur requis",
          actions_entreprise: "• Vérification alimentation électrique\n• Test thermique\n• Contrôle des connexions",
          cout_estime: "1200",
          priorite: "critique"
        }
      }
    ]
  },

  // Problèmes qualité
  quality: {
    category: "🎯 Problèmes Qualité",
    templates: [
      {
        id: "label_defect",
        name: "Défaut Étiquetage",
        icon: "🏷️",
        description: "Problèmes d'étiquetage (PAGO)",
        data: {
          probleme_initial: "Étiquettes mal positionnées ou décollées (PAGO)",
          phenomene_produit: "Étiquettes de travers, bulles d'air, ou décollement partiel",
          phenomene_ideal: "Étiquettes parfaitement alignées et adhérentes",
          check_centerlines: "nok",
          check_centerlines_details: "Vérification alignement tête d'étiquetage",
          check_visual_ctrl: "nok",
          actions_entreprise: "• Réajustement position tête d'étiquetage\n• Vérification pression d'application\n• Contrôle qualité adhésif",
          cout_estime: "300",
          priorite: "normale"
        }
      },
      {
        id: "filling_overflow",
        name: "Débordement Remplissage",
        icon: "🌊",
        description: "Débordement lors du remplissage (Ronchi)",
        data: {
          probleme_initial: "Débordement de produit pendant le remplissage (Ronchi)",
          phenomene_produit: "Niveau de remplissage dépassant la capacité prévue",
          phenomene_ideal: "Remplissage précis selon le niveau standard défini",
          check_centerlines: "nok",
          check_centerlines_details: "Calibrage du système de dosage nécessaire",
          actions_entreprise: "• Arrêt ligne pour nettoyage\n• Recalibrage système dosage\n• Test sur échantillons",
          cout_estime: "800",
          priorite: "haute"
        }
      }
    ]
  },

  // Problèmes matières
  material: {
    category: "📦 Problèmes Matières",
    templates: [
      {
        id: "material_shortage",
        name: "Rupture de Stock",
        icon: "📉",
        description: "Manque de matières premières",
        data: {
          probleme_initial: "Rupture de stock matière première",
          phenomene_produit: "Arrêt de production par manque de matière",
          phenomene_ideal: "Stock suffisant pour maintenir la cadence de production",
          materiaux_conformes: false,
          materiaux_details: "Stock épuisé - réapprovisionnement urgent",
          actions_entreprise: "• Contact fournisseur urgent\n• Vérification stock de sécurité\n• Planning réapprovisionnement",
          cout_estime: "2000",
          priorite: "critique"
        }
      },
      {
        id: "defective_material",
        name: "Matière Défectueuse",
        icon: "❌",
        description: "Défaut qualité matière première",
        data: {
          probleme_initial: "Matière première non conforme aux spécifications",
          phenomene_produit: "Qualité produit final dégradée par défaut matière",
          phenomene_ideal: "Matière première conforme aux standards qualité",
          materiaux_conformes: false,
          materiaux_details: "Non-conformité détectée - lot à retourner",
          check_visual_ctrl: "nok",
          actions_entreprise: "• Quarantaine du lot défectueux\n• Contact qualité fournisseur\n• Contrôle renforcé réception",
          cout_estime: "1500",
          priorite: "haute"
        }
      }
    ]
  },

  // Problèmes opérateurs
  operator: {
    category: "👥 Problèmes Opérateurs",
    templates: [
      {
        id: "operator_error",
        name: "Erreur Opérateur",
        icon: "🤷",
        description: "Erreur de manipulation ou procédure",
        data: {
          probleme_initial: "Erreur de manipulation opérateur",
          phenomene_produit: "Non-respect de la procédure standard",
          phenomene_ideal: "Application stricte des procédures définies",
          operateurs_qualifies: false,
          standard_defini: true,
          process_connu: false,
          actions_entreprise: "• Formation rappel procédure\n• Vérification compétences\n• Mise à jour instruction de travail",
          cout_estime: "200",
          priorite: "normale"
        }
      },
      {
        id: "training_needed",
        name: "Formation Requise",
        icon: "📚",
        description: "Besoin de formation sur nouveau process",
        data: {
          probleme_initial: "Opérateur non formé sur nouvelle procédure",
          phenomene_produit: "Hésitations et erreurs lors de l'exécution",
          phenomene_ideal: "Maîtrise complète de la nouvelle procédure",
          operateurs_qualifies: false,
          standard_defini: true,
          process_connu: false,
          tache_standard_possible: true,
          actions_entreprise: "• Organisation session formation\n• Création support pédagogique\n• Evaluation compétences",
          cout_estime: "400",
          priorite: "normale"
        }
      }
    ]
  }
};

// Fonction pour obtenir tous les templates par catégorie
export const getTemplatesByCategory = () => {
  return Object.values(FORM_TEMPLATES);
};

// Fonction pour rechercher un template par ID
export const getTemplateById = (id) => {
  for (const category of Object.values(FORM_TEMPLATES)) {
    const template = category.templates.find(t => t.id === id);
    if (template) return template;
  }
  return null;
};

// Fonction pour rechercher des templates par mots-clés
export const searchTemplates = (query) => {
  if (!query || query.length < 2) return [];
  
  const results = [];
  const searchTerm = query.toLowerCase();
  
  for (const category of Object.values(FORM_TEMPLATES)) {
    for (const template of category.templates) {
      if (
        template.name.toLowerCase().includes(searchTerm) ||
        template.description.toLowerCase().includes(searchTerm) ||
        template.data.probleme_initial.toLowerCase().includes(searchTerm)
      ) {
        results.push({
          ...template,
          category: category.category
        });
      }
    }
  }
  
  return results;
};

// Templates rapides pour les équipements spécifiques de la Ligne B3
export const EQUIPMENT_QUICK_TEMPLATES = {
  "PACE": [
    "Arrêt moulin",
    "Défaut redressement", 
    "Problème flammage"
  ],
  "PAGO": [
    "Décollement étiquettes",
    "Erreur retournement",
    "Défaut étiquetage face 1"
  ],
  "Ronchi": [
    "Débordement remplissage",
    "Problème vissage",
    "Défaut UFI"
  ],
  "Formeur": [
    "Collage défaillant",
    "Erreur extraction",
    "Problème pressage"
  ],
  "Encaisseur": [
    "Chute flacons",
    "Défaut berceau",
    "Problème Slatt"
  ],
  "Scotcheuse": [
    "Scotch mal positionné",
    "Cassette défaillante",
    "Adhésion insuffisante"
  ],
  "Calp": [
    "Défaut hauteur",
    "Problème cellule contrôle",
    "Erreur station"
  ],
  "Banderoleuse": [
    "Film mal tendu",
    "Instabilité palette",
    "Défaut filmage"
  ],
  "Palettiseur": [
    "Blocage pousseur",
    "Erreur fil",
    "Problème table tournante"
  ]
};


